export default __webpack_public_path__ + "static/media/truck.8b9b33d7.svg";